import CopyIconButton from '@/components/ui/copy-to-clipboard/copy-icon-button';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Tables } from '@/types/database.types';
import { formatAPIKey } from '@/utils';
import { fDate } from '@/utils/formatTime';

type Props = {
  data:
    | {
        id?: string | number;
        name: string;
        apiKey: string;
        createDate: string;
        workspaceId: string;
      }[]
    | [];
  isLoading: boolean;
};
const TableLLMAPIKey = ({ data, isLoading }: Props) => {
  return (
    <div className="grid overflow-x-auto">
      <Table className="w-full table-fixed">
        <colgroup>
          <col className="w-full min-w-[200px]" />
          <col className="w-full min-w-[200px]" />
          <col className="w-[100px]" />
          <col className="w-full" />
        </colgroup>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Api key</TableHead>
            <TableHead>Create Date</TableHead>
            <TableHead>Workspece</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading && (
            <TableRow>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableCell key={index}>
                  <Skeleton className="h-4" />
                </TableCell>
              ))}
            </TableRow>
          )}
          {data &&
            data.map((item) => (
              <TableRow key={item.id}>
                <TableCell className="truncate">{item.name}</TableCell>
                <TableCell className="truncate font-medium">
                  <div className="flex items-center gap-1">
                    {formatAPIKey(item.apiKey)}
                    <CopyIconButton text={item.apiKey} />
                  </div>
                </TableCell>
                <TableCell>{fDate(item.createDate)}</TableCell>
                <TableCell className='text-xs'>{item.workspaceId}</TableCell>
                {/* <TableCell>{fDate(item.lastUsed)}</TableCell> */}
              </TableRow>
            ))}
        </TableBody>
        {data?.length === 0 && <TableCaption>No API key.</TableCaption>}
      </Table>
    </div>
  );
};

export default TableLLMAPIKey;
